import { render, staticRenderFns } from "./ReasonCodes.vue?vue&type=template&id=6bc511fa"
import script from "./ReasonCodes.vue?vue&type=script&lang=js"
export * from "./ReasonCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports